import { useEffect } from "react"
import {
  deleteCurrentSetting,
  deliverySetting0,
  isCurrentDeliveryS,
  setDeliverySetting0
} from "@/react/SetShippingFeesView/SetShippingFeesLogic.tsx";
import _ from "lodash";
import clsx from "clsx";
import { deliverySettingsRadius } from "@/react/DeliveryManagementView/google-map-logic.ts";
import { LL0 } from "@/react/core/I18nService.tsx";


const DeliveryFeesTable = ({ className }: { className: string }) => {
  useEffect(() => {
    if (deliverySettingsRadius()?.length && _.isEmpty(deliverySetting0)) {
      setDeliverySetting0(deliverySettingsRadius()[0])
    }
  }, [deliverySettingsRadius()?.length])

  return (
    <div className="flex flex-col flex-1 h-full overflow-auto Tablet_768:hidden">
      <div className="min-w-full grid grid-cols-[2fr_2fr_2fr_2fr_1fr]">
        {/* Header */}
        <div className="bg-[#364150] border-[#fff] border-r-[1px] border-b-[1px] border-solid h-[38.5px] flex items-center justify-center py-[10px] px-[8px]">
          <b className="text-white sm:text-[12px] mq768:text-[13px] mq600:text-[12px] h.414:text-[12px]">
            {LL0().deliveryManagement.distanceToKm()}
          </b>
        </div>
        <div className="bg-[#364150] border-[#fff] border-r-[1px] border-b-[1px] border-solid h-[38.5px] flex items-center justify-center py-[10px] px-[8px]">
          <b className="text-white sm:text-[12px] mq768:text-[13px] mq600:text-[12px] h.414:text-[12px]">
            {LL0().deliveryManagement.deliveryCost()}
          </b>
        </div>
        <div className="bg-[#364150] border-[#fff] border-r-[1px] border-b-[1px] border-solid h-[38.5px] flex items-center justify-center py-[10px] px-[8px]">
          <b className="text-white sm:text-[12px] mq768:text-[13px] mq600:text-[12px] h.414:text-[12px]">
            {LL0().deliveryManagement.minOrderValue()}
          </b>
        </div>
        <div className="bg-[#364150] border-[#fff] border-r-[1px] border-b-[1px] border-solid h-[38.5px] flex items-center justify-center py-[10px] px-[8px]">
          <b className="text-white sm:text-[12px] mq768:text-[13px] mq600:text-[12px] h.414:text-[12px]">
            {LL0().deliveryManagement.freeDeliveryFrom()}
          </b>
        </div>
        <div className="bg-[#364150] border-[#fff] border-r-[1px] border-b-[1px] border-solid h-[38.5px]" />
      </div>
      {/* Content rows */}
      {deliverySettingsRadius().map((setting: any, index) => (
          <div
            onClick={() => {
              setDeliverySetting0(setting)
            }}
            key={index}
            className={clsx("self-stretch relative min-w-full grid grid-cols-[2fr_2fr_2fr_2fr_1fr]",
              { 'border-[2px] border-[#D902A7]': isCurrentDeliveryS(setting._id) })}>
            {/*{isCurrentDeliveryS(setting._id) && <div*/}
            {/*  className={'border-[2px] border-[#D902A7] col-span-full absolute inset-0 z-[10] m-0 pointer-events-auto'}*/}
            {/*  onDoubleClick={(e) => {*/}
            {/*    e.stopPropagation();*/}
            {/*    console.log('🪲 setting ', setting);*/}
            {/*  }}*/}
            {/*/>}*/}
            <div
              className="bg-white h-[55px] border-[#364150] border-r-[1px] border-b-[1px] flex items-center justify-center font-semibold">
              {setting.distance ?? "-"}
            </div>
            <div
              className="bg-white h-[55px] border-[#364150] border-r-[1px] border-b-[1px] flex items-center justify-center font-semibold">
              {setting.cost ?? "-"}
            </div>
            <div
              className="bg-white h-[55px] border-[#364150] border-r-[1px] border-b-[1px] flex items-center justify-center font-semibold">
              {setting.minOrderValue ?? "-"}
            </div>
            <div
              className="bg-white h-[55px] border-[#364150] border-r-[1px] border-b-[1px] flex items-center justify-center font-semibold">
              {setting.freeFrom ?? "-"}
            </div>
            <div
              onClick={async (e) => {
                e.stopPropagation();
                e.preventDefault();
                await deleteCurrentSetting(setting)
              }}
              className="bg-white h-[55px] border-[#364150] border-b-[1px] flex items-center justify-center font-semibold">
              <img
                className="w-[28px] h-[28px] object-cover cursor-pointer"
                alt="Delete"
                src="/iconrecycle-bin@2x.png"
              />
            </div>
          </div>
        )
      )}
    </div>
  )
}

export default DeliveryFeesTable

